import { useConnections, useToolkits } from '@/features/integrations'
import { toolkitLogo } from './toolkitLogo'

export function useToolkitLogo(slug) {
  const toolkits = useToolkits()
  const connections = useConnections()
  return toolkitLogo(toolkits.data, connections.data, slug)
}
